function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100vw 100vh",
    fill: "none",
    style: {
      maxWidth: "100%",
      height: "auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_127_13",
    x1: 0,
    y1: 0,
    x2: "100%",
    y2: "100%",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#D5998B",
    style: {
      stopColor: "#D5998B",
      stopColor: "color(display-p3 0.8359 0.6000 0.5440)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E3F3D",
    style: {
      stopColor: "#9E3F3D",
      stopColor: "color(display-p3 0.6196 0.2471 0.2392)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_127_13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#28293E",
    style: {
      fill: "#28293E",
      fill: "color(display-p3 0.1569 0.1608 0.2431)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#paint0_linear_127_13)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.721 528.492l268.916 146.689L138.083 798.116L178.721 528.492Z",
    fill: "#AF3A2B",
    fillOpacity: 0.22,
    style: {
      fill: "#AF3A2B",
      fill: "color(display-p3 0.6863 0.2275 0.1686)",
      fillOpacity: 0.22
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.854 644.459l302.66 -86.882L713.693 840.036L491.854 644.459Z",
    fill: "#AF3A2B",
    fillOpacity: 0.22,
    style: {
      fill: "#AF3A2B",
      fill: "color(display-p3 0.6863 0.2275 0.1686)",
      fillOpacity: 0.22
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.824 481.166l246.425 -172.951L1015.984 596.644L726.824 481.166Z",
    fill: "#AF3A2B",
    fillOpacity: 0.22,
    style: {
      fill: "#AF3A2B",
      fill: "color(display-p3 0.6863 0.2275 0.1686)",
      fillOpacity: 0.22
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.053 349.246l-18.672 -271.368L1288.23 218.704L1008.053 349.246Z",
    fill: "#AF3A2B",
    fillOpacity: 0.22,
    style: {
      fill: "#AF3A2B",
      fill: "color(display-p3 0.6863 0.2275 0.1686)",
      fillOpacity: 0.22
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1385.62 245.904l-0.9 128.403L1249.22 300.796L1385.62 245.904Z",
    fill: "#AF3A2B",
    style: {
      fill: "#AF3A2B",
      fill: "color(display-p3 0.6863 0.2275 0.1686)",
      fillOpacity: 0.22
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingsvg);
export default __webpack_public_path__ + "static/media/landingsvg.033df00636b8d0bead9a8aaad6df69ef.svg";
export { ForwardRef as ReactComponent };